import { z } from "zod";
import { ERemitterType } from "@zeal/common";

export const patchCanadianPayrollBusinessEntitySchema = z.object({
  companyID: z.string(),
  business_number: z.string().length(15).optional(),
  legal_registration_number: z.string().optional(),
  remitter_type: z
    .nativeEnum(ERemitterType)
    .default(ERemitterType.REGULAR)
    .optional(),
});

export type TPatchCanadianPayrollBusinessEntityRequest = z.infer<
  typeof patchCanadianPayrollBusinessEntitySchema
>;

export type TPatchCanadianPayrollBusinessEntityResponse = {
  success: boolean;
  business_entity_id: string;
};
